module.exports = {
  product: 'Flow-Access',
  api_base: '/api/portal/1.0/',
  systemName: 'Access',
  enable: {
    portalRedirectAfterInstallation: false,
    search: false,
    enterManually: false,
    checkFiberOutlet: false
  },
  phrase: {
    saveIfExists: 'This address is correct',
    saveIfEmpty: 'Create new address',
    saveIfChanged: 'Update address connection'
  },
  portalURL: '/portal/'
}



// WEBPACK FOOTER //
// ./src/projects/flow-gui-installation/config/installation.js